const $ = jQuery;

function sliderProductGallery() {
    $('.product-gallery-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        dots: false,
        asNavFor: '.product-gallery-slider-nav'
    });
    $('.product-gallery-slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        asNavFor: '.product-gallery-slider',
        dots: true,
        arrows: false,
        focusOnSelect: true,
        // vertical: !helpers.isMobile()
    });
}

function sliderAtHero() {
    $('.hero-section .hero-slider').slick({
        autoplay: true,
        autoplaySpeed: 4500,
        infinite: true,
        fade: true,
        speed: 1100,
        pauseOnHover: false,
        pauseOnFocus: false
        // cssEase: 'ease-out'
    });
}

function sliderHome() {
    $('.js-slider-home').slick(
        {
            autoplay: true,
            autoplaySpeed: 4000,
            infinite: true,
            fade: true,
            speed: 3100,
            pauseOnHover: false,
            pauseOnFocus: false,
            cssEase: 'ease-in-out'
        }
    )
}

export default function () {
    // sliderAtHero();
    sliderHome();
    sliderProductGallery();
};

